import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { LoginPage } from './pages/login/login.page';
import { ConsultantOverviewPage } from './pages/tour-consultant/consultant-overview/consultant-overview.page';
import { BookingPage } from './pages/tour-consultant/booking/booking.page';
import { OrdersPage } from './pages/tour-consultant/orders/orders.page';
import { ProfilePage } from './pages/profile/profile.page';
import { AuthGuard } from './guards/auth.guard';
import { IsNotTourOperatorGuard } from './guards/is-not-tour-operator.guard';
import { PacksPage } from './pages/tour-consultant/packs/packs.page';

const routes: Routes = [
	{
		path: 'login',
		component: LoginPage
	},
	{
		path: 'profile',
		component: ProfilePage,
		canActivate: [AuthGuard]
	},
	{
		path: 'tour-operator',
		loadChildren: () => import('./pages/tour-operator/tabs/tabs.module').then(m => m.TabsPageModule),
		canActivateChild: [AuthGuard]
	},
	{
		path: 'tour-consultant',
		canActivateChild: [AuthGuard],
		children: [
			{
				path: 'booking',
				component: ConsultantOverviewPage
			},
			{
				path: 'booking/:tourId',
				component: BookingPage
			},
			{
				path: 'orders',
				component: OrdersPage
			},
			{
				path: 'packs',
				component: PacksPage
			}
		]
	},
	{
		path: '',
		redirectTo: '/login',
		pathMatch: 'full'
	},
	{
		path: '**',
		redirectTo: '/login',
		pathMatch: 'full'
	}
];
@NgModule({
	imports: [
		RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
	],
	exports: [RouterModule]
})
export class AppRoutingModule {}
